import { render, staticRenderFns } from "./UneditablePriceCell.vue?vue&type=template&id=7bbc32b6&scoped=true&"
import script from "./UneditablePriceCell.vue?vue&type=script&lang=ts&"
export * from "./UneditablePriceCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbc32b6",
  null
  
)

export default component.exports